// oxlint-disable-next-line no-restricted-imports
import { cloneDeep as cloneDeepApollo } from '@apollo/client/utilities';

export const cloneDeep = <T>(obj: T): T => {
  return cloneDeepApollo(obj);
};
